import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import AppTheme from '../../shared-theme/AppTheme';

// import AppAppBar from './components/AppAppBar';
import Hero from './components/Hero';
import LogoCollection from './components/LogoCollection';
import Features from './components/Features';
import Highlights from './components/Highlights';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function HomePage(props) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      {/* <AppAppBar /> */}
      <Hero
        data={{
          title:"TalentRealm",
          subtitle:"Smart Resume Analyzer & Job Matching",
          summary:"Connect candidates and recruiters with AI-driven precision. Upload resumes, create job postings, and let TalentRealm calculate the perfect match score instantly.",
          ctaText:"Get Started",
          secondaryCtaText:"Learn More"
          }}
      />
      <div>
        {/* Trusted companies logos */}
        <LogoCollection
          heading="Trusted by HR teams and job seekers worldwide"
        />

        {/* Core features of TalentRealm */}
        <Features/>

        <Divider />

        {/* Recruiter & candidate success stories */}
        <Testimonials/>

        <Divider />

        {/* AI highlights & advantages */}
        <Highlights/>

        <Divider />

        {/* Subscription & pricing model */}
        <Pricing/>

        <Divider />

        {/* Common questions for recruiters & candidates */}
        <FAQ/>

        <Divider />

        {/* Footer with newsletter + social links */}
        <Footer />
      </div>
    </AppTheme>
  );
}
